import { render } from "./User-add.vue?vue&type=template&id=03ffe300"
import script from "./User-add.vue?vue&type=script&lang=js"
export * from "./User-add.vue?vue&type=script&lang=js"

import "./User-add.vue?vue&type=style&index=0&id=03ffe300&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__